import { useContext } from "react";
import { DeploymentRequestDetailPageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(
    DeploymentRequestDetailPageContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
